/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chars_UnitInputs */



/**
* | output |
* | --- |
* | "char(s)" |
*
* @param {Chars_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const chars_unit = /** @type {((inputs?: Chars_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chars_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("caract.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("carattere/i")
	if (locale === "ru") return /** @type {LocalizedString} */ ("символ(ы)")
	if (locale === "es") return /** @type {LocalizedString} */ ("carácter(es)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षर(ओं)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("caractere(s)")
	return /** @type {LocalizedString} */ ("char(s)")
});